var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bot repair"},[_c('div',{staticClass:"content"},[_c('div',{ref:_vm.message.id,staticClass:"repair"})]),_c('div',{staticClass:"time"},[(_vm.typingCompleted)?_c('span',[_vm._v(" "+_vm._s(_vm._f("localTime")(_vm.message.createAt)))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }